import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TramiteValidacionJudicialDto } from '../dto/tramites/tramite-validacion-judicial.dto';
import { TramiteResponseDTO } from '../dto/tramites/tramite.dto';
import { Observable } from 'rxjs';
import {
  RespuestaEliminarDTO,
  TablaProfesionalesDTO
} from "../modules/tramites/supersociedades/liquidacion-judicial/models/liquidacion-judicial-DTO";
import {FormFieldOption} from "../dto/util/form-field";

@Injectable({
  providedIn: 'root'
})
export class TramiteSupersociedadesValidacionJudicialService {

  private readonly apiUrl = environment.apiUrl;
  private readonly baseUrlSociedad = '/supersociedades/vji/sociedad';
  private readonly baseUrlSucursal = '/supersociedades/vji/sucursal';
  private urlProfesionales = `${environment.apiUrl}/insolvencia`;



  constructor(private readonly http: HttpClient) { }

  crearTramiteSSVjiSociedad(
    data: TramiteValidacionJudicialDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrlSociedad}`,
      data
    );
  }
  listaRevisores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/revisores-fiscales?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaApoderados(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/apoderados?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaContadores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/contadores?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleRevisores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/revisores-fiscales/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleApoderados(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/apoderados/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  listaSimpleContadores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/contadores/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }
  eliminarRevisor(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-revisor?id=${id}`,
      {}
    );
  }
  eliminarApoderado(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-apoderado?id=${id}`,
      {}
    );
  }
  eliminarContador(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-contador?id=${id}`,
      {}
    );
  }
}
